import { Component, Input, Output, EventEmitter, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { ProjectItemWithSelectionComponent } from './project-item-withselection.component';
import { GenericValidator } from '../shared/generic-validator';
import { Observable } from 'rxjs';

@Component({
    selector: 'project-contact',
    template: require('./project-contact.component.html')
})
export class ProjectContactComponent extends ProjectItemWithSelectionComponent {
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    displayMessage: { [key: string]: string } = {};
    
    constructor() {
        super();
        this.validationMessages = {
            email: {
                pattern: 'Please Enter a valid Email.'
            },
            name: {
                // required: 'Please Enter the Name.',
                maxlength: 'Contact Name Cannot be Longer than 80 Characters'
            }
        }
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

   


    ngAfterViewInit() {
        
        //Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));
    
        //Merge the blur event observable with the valueChanges observable
        Observable.merge(this.projectItemForm.valueChanges, ...controlBlurs)
        .debounceTime(500)
        .subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.projectItemForm);
        });


        var inputs = document.getElementsByTagName("select");
        for(var i = 0; i < inputs.length; i++) {
           
            /*validation when a new product contact is added*/
            if(inputs[i].id !== '' &&  inputs[i].value === 'Project Contact title'){
                this.hideEmailNotification(inputs, i);
            }
            if(inputs.length === 1 && inputs[i].id !== '' &&  inputs[i].value === ''){
                this.hideEmailNotification(inputs, i);
            }
        }

    }

    hideEmailNotification(inputs, i){
        var current = inputs[i].id.replace('title','');
        
        inputs[i].value = '';
        document.getElementById('emailNotificationDiv'+ current).setAttribute('hidden','true');
        document.getElementById('emailDiv'+ current).classList.remove('l2');
        document.getElementById('emailDiv'+ current).classList.add('l4');
    }
    
    onChange(projectContact, current) {
        
        if(projectContact.target.value === "Clearance Contact"){
            document.getElementById('emailNotificationDiv'+ current).removeAttribute('hidden');
            document.getElementById('emailDiv'+ current).classList.remove('l4');
            document.getElementById('emailDiv'+ current).classList.add('l2');
        }
        else{
            document.getElementById('emailNotificationDiv'+ current).setAttribute('hidden','true');
            document.getElementById('emailDiv'+ current).classList.remove('l2');
            document.getElementById('emailDiv'+ current).classList.add('l4');
        }
        
    }
  
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project-contact.component.ts